export type PasswordTestResult = {
  /** if the password has at least 8 characters */
  length: boolean;
  /** if the password has at least 1 lowercase character */
  lower: boolean;
  /** if the password has at least 1 uppercase character */
  upper: boolean;
  /** if the password has at least 1 numeric character */
  numeric: boolean;
  /** if the password has at least 1 special character */
  special: boolean;
  /** if the password has at least 3 of the required 4 types of characters */
  characters: boolean;
  /** if the password fully passes the test */
  pass: boolean;
};

export function testPassword(password: string): PasswordTestResult {
  const r: PasswordTestResult = {
    length: /(?=.{8,})/.test(password),
    lower: /(?=.*[a-z])/.test(password),
    upper: /(?=.*[A-Z])/.test(password),
    numeric: /(?=.*[0-9])/.test(password),
    special: /(?=.*[!@#$%^&*])/.test(password),
    characters: false,
    pass: false,
  };

  // at least 3/4 character conditions are met
  r.characters = +r.lower + +r.upper + +r.numeric + +r.special >= 3;
  r.pass = r.length && r.characters;
  return r;
}
